(function () {
  var prevPreload = window.preloadImages;

  window.preloadImages = function (element) {
    element = element || document;
    var lazyImages = element.querySelectorAll('img.lazy');
    for (var i = 0; i < lazyImages.length; i++) {
      var img = lazyImages[i];
      if (!img.complete) {
        img.addEventListener('load', lazyImageLoad, false);
      } else {
        lazyImageLoad({ currentTarget: img });
      }
    }
  };

  function lazyImageLoad(e) {
    e.currentTarget.classList.add('lazyloaded');
  }

  window.preloadImages();

  if (typeof prevPreload === 'function' && prevPreload !== window.preloadImages) {
    try {
      prevPreload(document);
    } catch (err) {}
  }

  window.prlxElementsPusher = function (element) {
    var elements = element.querySelectorAll('[data-scroll-speed]');
    if (element.classList.contains('mount-parallax-w-padding')) {
      var i = elements.length - 1;
      while (i >= 0) {
        if (Number(elements[i].getAttribute('data-scroll-speed')) < 0) {
          elements[i].setAttribute('data-scroll-speed', '-.1');
          break;
        }
        i--;
      }
    }
    elements.forEach(function (el) {
      window.prlxElements.push({
        element: el,
        factor: Number(el.getAttribute('data-scroll-speed')),
        parent: document.getElementById(el.getAttribute('data-scroll-parent')),
        mirror: el.hasAttribute('data-scroll-mirror'),
        resistance: el.hasAttribute('data-scroll-resistance')
      });
    });
  };

  window.prlxElements = [];
  window.prlxRaf = true;
  document.querySelectorAll('.mount-parallax').forEach(function (element) {
    window.prlxElementsPusher(element);
  });

  window.addEventListener(
    'scroll',
    function () {
      if (window.prlxRaf) {
        window.prlxRaf = false;
        requestAnimationFrame(window.prlxAnimation.bind(this));
      }
    },
    { passive: true }
  );

  window.prlxAnimation = function () {
    var windowHeight = document.documentElement.clientHeight;
    var windowWidth = document.documentElement.clientWidth;
    window.prlxElements.forEach(function (item) {
      var elementY = item.element.getBoundingClientRect().y;
      if (item.resistance) {
        var parentY = item.parent.getBoundingClientRect().y - windowHeight;
        if (parentY < 0 && Math.abs(parentY) < item.parent.offsetHeight + windowHeight) {
          var prlxRes = Math.abs(parentY) * Math.min(windowHeight, windowWidth) / (item.parent.offsetHeight + windowHeight);
          item.element.style.transform = 'translateY(' + prlxRes + 'px)';
        }
      } else if (elementY < windowHeight * 2 && elementY > (item.element.offsetHeight + windowHeight) * -1) {
        var prlx = 0;
        if (item.parent) {
          prlx = (item.parent.getBoundingClientRect().y - (windowHeight - item.parent.offsetHeight) / 2) * item.factor;
          if (windowWidth < 600) {
            prlx /= 2;
          }
          if (item.mirror && prlx < 0) {
            prlx = 0;
          }
        } else {
          prlx = Math.round((window.scrollY + windowHeight - item.element.offsetTop) * item.factor / -2);
          if (item.padding) {
            if (prlx >= 0) {
              item.element.parentElement.style.paddingBottom = prlx + 'px';
            } else {
              item.element.parentElement.style.paddingBottom = '0px';
            }
          }
        }
        if (Math.abs(prlx) < windowHeight) {
          item.element.style.transform = 'translateY(' + prlx + 'px)';
        }
      }
    });
    this.prlxRaf = true;
  };

  window.prlxAnimation();

  window.addEventListener('resize', function () {
    window.prlxAnimation();
  });

  if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
    document.body.classList.remove('no-touchevents');
    document.body.classList.add('touchevents');
  }
})();
